import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import AdminNavbar from './components/AdminNavbar';
import { Outlet } from 'react-router-dom';
import './styles/AdminLayout.css';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase'; // 👈 Import your Firebase config
import { collection, onSnapshot } from 'firebase/firestore'; // 👈 Firestore methods

const AdminLayout = () => {
  const navigate = useNavigate();
  const [newOrder, setNewOrder] = useState(false);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      const isLoggedIn = localStorage.getItem('isAdminLoggedIn');
      if (isLoggedIn !== 'true') {
        navigate('/admin/login');
      }
    }, 100);
  }, [navigate]);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "orders"), (snapshot) => {
      const fetchedOrders = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setOrders(fetchedOrders);
      if (fetchedOrders.length > 0) {
        setNewOrder(true);
      }
    });

    return () => unsubscribe(); // Clean up listener
  }, []);

  return (
    <div className="admin-layout">
      <Sidebar />
      <AdminNavbar newOrder={newOrder} setNewOrder={setNewOrder} orders={orders} />
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
